import React from 'react'
import "./LeftSideModal.scss";
import useModals from '@/shared/hooks/useModal';

interface ILeftSideModal extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>{
    
}
function LeftSideModal({children, ...props}: ILeftSideModal) {
    const {closeModal} = useModals()
    return (
        <div className='LeftSide' onClick={()=>{closeModal()}}>
            <div {...props} className='LeftModal' onClick={(e)=>e.stopPropagation()}>
                {children}
            </div>
        </div>
    )
}

export default LeftSideModal